<template>
  <messages-area :api="api" profile="customer" />
</template>

<script>
import MessagesArea from "@/components/messages/MessagesArea.vue";
import pitchCustomerApi from "@/shared/pitchCustomerApi";

// Card 17trt6jbffe: Mensagens do aluno.
export default {
  name: "CustomerMessages",
  components: { MessagesArea },
  data() {
    return { api: pitchCustomerApi };
  },
};
</script>
